<template>
    <table class="table align-middle table-draggable">
        <thead @drop="onDrop($event, {type: 2, id: 0})" @dragover.prevent @dragenter.prevent>
            <tr>
                <th scope="col">
                    <div class="th-inner"></div>
                </th>
                <th scope="col">
                    <div class="th-inner">Название</div>
                </th>
                <th scope="col">
                    <div class="th-inner">Бренд</div>
                </th>
                <th scope="col">
                    <div class="th-inner">Дата создания</div>
                </th>
                <th scope="col">
                    <div class="th-inner">Дата изменения</div>
                </th>

                <th scope="col">
                    <div class="th-inner">Пользователь</div>
                </th>

                <th scope="col">Действия</th>
            </tr>
        </thead>
        <tbody>
        <template v-for="row in items">
            <content-table-row-component
                @dragAction="startDrag"
                @dragDropAction="onDrop"
                @openDir="openDir"
                :row="row" :deep="0">
            </content-table-row-component>
        </template>
        </tbody>
    </table>
</template>

<script>
import { mapMutations, mapState } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "ContentTableComponent",

    data: function () {
        return {
            delay: 500,
            clicks: 0,
            timer: undefined,
            drag_item: {}
        }
    },

    computed: {
        ...mapState('content', ['items', 'selectedRows'])
    },

    emits: [
        "viewItem",
        "changeRights",
        "content",
        "group",
        "playlist",
        "addToDir",
        "contentDir",
    ],

    methods: {
        ...mapMutations('content', ['clearSelectedRows']),

        actionClick: function (emit, params) {
            event.preventDefault();
            this.$emit(emit, params);
        },

        async openDir(item) {
            return await this.$emit('contentDir', item);
        },

        startDrag(event, item) {
            event.dataTransfer.dropEffect = 'move';
            event.dataTransfer.effectAllowed = 'move';

            if (!this.selectedRows.find(row => row.id === item.id)) {
                this.clearSelectedRows();
            }

            if (this.selectedRows.length > 0) {
                this.drag_item = [...this.selectedRows];
            } else {
                this.drag_item = [item];
            }

            const titles = this.drag_item.map(el => el.name || el.title || `#${el.id}`);
            event.dataTransfer.setData('text/plain', titles.join('\n'));

            // Создаём кастомный preview
            const dragText = document.createElement('div');
            dragText.style.position = 'absolute';
            dragText.style.top = '-9999px';
            dragText.style.fontSize = '14px';
            dragText.style.fontWeight = 'bold';
            dragText.style.padding = '6px 10px';
            dragText.style.background = 'rgba(0,0,0,0.75)';
            dragText.style.color = 'white';
            dragText.style.borderRadius = '6px';
            dragText.style.pointerEvents = 'none';
            dragText.style.maxWidth = '300px';
            dragText.style.display = 'flex';
            dragText.style.flexDirection = 'column';
            dragText.style.gap = '2px';

            // Добавляем каждое имя как отдельный элемент с троеточием
            titles.forEach(title => {
                const line = document.createElement('div');
                line.textContent = title;
                line.style.whiteSpace = 'nowrap';       // одна строка
                line.style.overflow = 'hidden';         // обрезаем лишнее
                line.style.textOverflow = 'ellipsis';   // троеточие
                dragText.appendChild(line);
            });

            document.body.appendChild(dragText);
            event.dataTransfer.setDragImage(dragText, 0, 0);

            setTimeout(() => document.body.removeChild(dragText), 0);
        },

        onDrop(event, targetContent) {
            if (targetContent.hasOwnProperty('type')) {
                // this.$emit('addToDir', this.drag_item, group.type === 2 ? group.id : group.group_id);
                this.$emit('addToDir', this.drag_item, targetContent);
            }
            this.drag_item = [];
            this.clearSelectedRows();
        }
    }
}
</script>

<style scoped>
    .table-row-draggable {
        border:1px solid white;
        border-collapse: collapse;
        cursor:pointer;
    }

    .table-draggable {
        border-collapse: collapse;
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10+ and Edge */
        user-select: none;
    }
</style>
